import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { getJson } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Post, useWallState } from "@/components/community/Wall";

export default function WallPost() {
  const { id } = useParams();
  const { t } = useLang();
  const [posts, setPosts] = useState(null);
  const ws = useWallState(setPosts);
  useEffect(() => {
    getJson(`/community/wall/${id}`).then((d) => setPosts(d ? [d] : []));
  }, [id]);
  return (
    <main className="px-5 pb-28 pt-32 md:px-10" data-testid="wall-post-page">
      <div className="mx-auto max-w-xl">
        <Link to="/comunidad?tab=pared" className="mono inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-[var(--muted)] hover:text-[var(--ink)]" data-testid="wall-post-back"><ArrowLeft size={14} /> {t("com.tab.pared")}</Link>
        <div className="mt-8">
          {posts === null && <Loader2 className="mx-auto animate-spin" />}
          {posts?.length === 0 && <p className="font-display text-3xl" data-testid="wall-post-not-found">{t("com.notFound")}</p>}
          {posts?.map((p) => <Post key={p.id} p={p} ws={ws} />)}
        </div>
      </div>
    </main>
  );
}
